<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <component-query :queryMode="playerQueryMode" :queryUserId="queryUserId" @usersData="getUsersData"></component-query>

                <el-table :data="playerData" border style="width: 50%;margin-bottom: 20px;"
                          @current-change="handlePlayerDataChange" highlight-current-row>
                  <el-table-column prop="id" label="用户id"  width="120"></el-table-column>
                  <el-table-column prop="server" label="游戏服编号" width="120"></el-table-column>
                  <el-table-column prop="email" label="sid" width="120"></el-table-column>
                  <el-table-column prop="channel" label="渠道" width="120"></el-table-column>
                  <el-table-column prop="nick" label="昵称"></el-table-column>
                  <el-table-column prop="level" label="等级"></el-table-column>
                    <el-table-column label="禁言状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.silence == 0">正常</span>
                            <span v-if="scope.row.silence == 1">禁言</span>
                            <span v-if="scope.row.silence == 2">伪禁言</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="封号状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.block == 0">正常</span>
                            <span v-if="scope.row.block == 1">后台封禁</span>
                            <span v-if="scope.row.block == 2">系统封禁</span>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="query-panel">
                    <el-form :inline="true">
                        <el-form-item label='查询内容' v-if="chatFindBO.chatChannel !== '200'">
                            <el-input v-model="content" placeholder="请输入查询内容"></el-input>
                        </el-form-item>
                        <el-form-item label='时间范围' v-if="chatFindBO.chatChannel !== '200'">
                            <el-date-picker v-model="dateTime" type="datetimerange" range-separator='-'
                                            start-placeholder='开始时间' end-placeholder='结束时间'
                                            format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="聊天频道类型">
                            <el-select v-model="chatFindBO.chatChannel" placeholder="请选择">
                                <el-option
                                    v-for="item in chatTypeOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="findPlayerChat">查询</el-button>
                        </el-form-item>
                    </el-form>

                    <el-table :data="dataHandled" border style="margin-top:20px;width: 100%">
                        <el-table-column prop="userId" label='用户id'>
                        </el-table-column>
                        <el-table-column prop="userNick" label='玩家昵称'>
                        </el-table-column>
                        <el-table-column prop="content" label='聊天信息'>
                        </el-table-column>
                        <el-table-column prop="gmtCreate" :formatter="formatterTime" label='创建时间'>
                        </el-table-column>
                        <el-table-column prop="chatChannel" label='频道类型'>
                            <template slot-scope="scope">
                                <span v-for="item in chatTypeOptions" v-if="scope.row.chatChannel == item.value">{{item.label}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label='操作'>
                            <template slot-scope="scope">
                                <el-button type="text" @click="delPlayerChatShow(scope.row)">撤回言论</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
                                       layout="total, prev, pager, next, jumper" :total="totalRow">
                        </el-pagination>
                    </div>
                </div>

                <el-dialog title="撤回言论" :visible.sync="delPlayerChatDialog" width="50%" lock-scroll center>
                    <el-form label-suffix=":" label-width="100px">
                        <el-form-item label="内部操作原因">
                            <el-autocomplete
                                class="inline-input"
                                type="textarea"
                                :maxlength="300"
                                show-word-limit
                                :autosize="{ minRows: 2}"
                                v-model="chatDelBO.reason"
                                :fetch-suggestions="querySearchReasonTemplate"
                                placeholder="请输入内容"
                                @select="handleSelectReason"
                            >
                                <template slot-scope="{ item }">
                                    <span class="addr">{{item.reason}}</span>
                                </template>
                            </el-autocomplete>
                        </el-form-item>

                        <el-form-item label="言论标签">
                            <el-autocomplete
                                class="inline-input"
                                type="textarea"
                                :maxlength="20"
                                show-word-limit
                                :autosize="{ minRows: 2}"
                                v-model="chatDelBO.chatLabel"
                                :fetch-suggestions="querySearchOpinionTag"
                                placeholder="请输入内容"
                                @select="handleSelectOpinionTag"
                            >
                                <template slot-scope="{ item }">
                                    <span class="addr">{{item.reason}}</span>
                                </template>
                            </el-autocomplete>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="delPlayerChatDialog = false">取消</el-button>
                        <el-button type="primary" @click="delPlayerChat">确认</el-button>
                    </div>
                </el-dialog>
            </section>
        </div>
    </el-card>
</template>

<script>
    import paginationController from '../../mixins/pagination'
    import actionConfirm from '../../mixins/action_confirm'
    import {
        mapState
    } from 'vuex';
    import componentServer from '../../components/component_server'
    import componentQuery from '../../components/component_query'
    import gameApi from '../../service/game_api'
    import commonApi from '../../service/common_api'
    import configSettingApi from '../../service/config_setting_api'
    import Utils from '../../lib/utils'

    export default {
        name: "query_chat",
        data() {
            return {
                Utils: Utils,
                title: this.$route.meta.title,
                playerQueryMode: ['mode_long_id','mode_short_id','mode_nick','mode_email'],
                playerData: [],
                chatTypeOptions: [
                    {
                        value: '2',
                        label: '世界频道'
                    },
                    {
                        value: '3',
                        label: '公会频道'
                    },
                    {
                        value: '4',
                        label: '招募频道'
                    },
                    {
                        value: '5',
                        label: '组队频道'
                    },
                    {
                        value: '100',
                        label: '好友私聊频道'
                    },
                    {
                        value: '200',
                        label: '异象聊天'
                    },
                ],
                configIdOptions: [],

                content: '',
                dateTime: '',
                chatFindBO: {
                    uri: '',
                    uid: '',
                    sid: '',
                    server:'',
                    chatChannel: '',
                    content: '',
                    stime: 0,
                    etime: 0
                },

                mapNodeData: [],
                monsterConfigData: [],
                immortalCocoonConfigData: [],
                resoundEventConfigData: [],
                resoundEventStoryConfigData: [],
                resoundEventStyleConfigData: [],
                tribeNodeConfigData: [],
                realmConfigData: [],

                delPlayerChatDialog: false,

                // 模板数据
                reasonTemplateData: [],
                chatDelBO: {
                    uri: '',
                    sid: '',
                    server:'',
                    uid: '',
                    id: '',
                    chatChannel: '',
                    reason: '',
                    chatLabel: '',
                    chatKey: ''
                },

                // 言论标签数据
                opinionTagData: [],

                //展示数据
                userNick: '',

                queryUserId: ''
            }
        },
        mixins: [paginationController, actionConfirm],
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
        },
        mounted() {
            this.getAllOptionData();
            this.getReasonListAll();
            this.getOpinionTagListAll();

            this.queryUserId = this.$route.query.userId;
            this.chatFindBO.chatChannel = this.$route.query.chatChannel;
        },
        methods: {
            getUsersData(val) {
                this.playerData = val;
            },
            handlePlayerDataChange(currentRow) {
                this.chatFindBO.uri = currentRow.uri;
                this.chatFindBO.uid = currentRow.id;
                this.chatFindBO.sid = currentRow.email;
                this.chatFindBO.server = currentRow.server;

                this.chatDelBO.uri = currentRow.uri;
                this.chatDelBO.uid = currentRow.id;
                this.chatDelBO.sid = currentRow.email;
                this.chatDelBO.server = currentRow.server;

                this.userNick = currentRow.nick;
            },

            getAllOptionData() {
                let self = this;
                let tables = 'map_node,monster_config,immortal_cocoon_config,resound_event_config,resound_event_story_config,resound_event_style_config,tribe_node,realm_config';
                commonApi.getConfs({
                    tables: tables
                }).then(res => {
                    self.mapNodeData = res.map_node;
                    self.monsterConfigData = res.monster_config;
                    self.immortalCocoonConfigData = res.immortal_cocoon_config;
                    self.resoundEventConfigData = res.resound_event_config;
                    self.resoundEventStoryConfigData = res.resound_event_story_config;
                    self.resoundEventStyleConfigData = res.resound_event_style_config;
                    self.tribeNodeConfigData = res.tribe_node;
                    self.realmConfigData = res.realm_config;

                    self.realmConfigData.forEach(item=>{
                        let identifier = item.identifier;
                        for (let monsterConfigDatum of self.monsterConfigData) {
                            if (monsterConfigDatum.id == identifier){
                                item.name = monsterConfigDatum.name;
                            }
                        }
                    })
                })
            },

            // 玩家聊天查询
            findPlayerChat() {
                if (this.chatFindBO.uid == '') {
                    this.$message({
                        type: 'error',
                        message: "未选中玩家"
                    })
                    return;
                } else if (this.chatFindBO.chatChannel == '') {
                    this.$message({
                        type: 'error',
                        message: "未选择聊天频道"
                    })
                    return;
                }

                this.chatFindBO.content = this.content;
                if ('' !== this.dateTime) {
                    this.chatFindBO.stime = this.dateTime[0].getTime();
                    this.chatFindBO.etime = this.dateTime[1].getTime();
                }

                gameApi.findChatLogs({
                    token: this.token,
                    chatFindBO: this.chatFindBO
                }).then(res => {
                    this.dataHandled = res.content.chatlogs;
                    this.dataHandled.forEach(item => {
                        item.userNick = this.userNick;
                        item.chatChannel = this.chatFindBO.chatChannel;
                        item.chatKey = this.getChatKey(item.userId,item.friendId);
                    })
                })
            },

            formatterTime(row) {
                var gmtCreate = row.gmtCreate;
                gmtCreate = Utils.formatDate(gmtCreate);
                return gmtCreate;
            },

            delPlayerChatShow(data) {
                this.delPlayerChatDialog = true;
                var chatDelBO = this.chatDelBO;
                chatDelBO.id = data.id;
                chatDelBO.chatChannel = this.chatFindBO.chatChannel;
                if (data.chatChannel == '100') {
                    chatDelBO.chatKey = data.chatKey;
                } else {
                    chatDelBO.chatKey = '';
                }

                chatDelBO.reason = '';
                chatDelBO.chatLabel = '';
            },

            // 玩家聊天删除
            delPlayerChat() {
                gameApi.delChatLog({
                    token: this.token,
                    chatDelBO: this.chatDelBO
                }).then(res => {
                    this.delPlayerChatDialog = false;
                    this.findPlayerChat();
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                })
            },

            // chatKey
            getChatKey(uid,friendUid) {
                var min = Math.min(uid, friendUid);
                var max = Math.max(uid, friendUid);
                return min + "_" + max;
            },

            // 模板列表查询
            getReasonListAll() {
                configSettingApi.reasonList({
                    token: this.token
                }).then(res => {
                    this.reasonTemplateData = res;
                })
            },

            querySearchReasonTemplate(queryString, cb) {
                var data = this.reasonTemplateData;
                var results = queryString ? data.filter(this.createFilter(queryString)) : data;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            createFilter(queryString) {
                return (data) => {
                    return (data.reason.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelectReason(item) {
                this.chatDelBO.reason = item.reason;
            },

            // 模板列表查询
            getOpinionTagListAll() {
                configSettingApi.opinionTagList({
                    token: this.token
                }).then(res => {
                    this.opinionTagData = res;
                })
            },

            querySearchOpinionTag(queryString, cb) {
                var data = this.opinionTagData;
                var results = queryString ? data.filter(this.createFilterOpinionTag(queryString)) : data;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            createFilterOpinionTag(queryString) {
                return (data) => {
                    return (data.reason.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelectOpinionTag(item) {
                this.chatDelBO.chatLabel = item.reason;
            },
        },
        components: {
            componentServer,
            componentQuery
        }
    }
</script>

<style scoped>

</style>

<style lang="less">
    .el-table__body tr.current-row>td {
        background-color: coral!important;
        color: #ffffff;
    }

    .inline-input {
        width: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/views/players/query_chat.vue